
import kirbylink from '../kirbylink.vue'
export default {
  components: { kirbylink },
    name:"smallCardAlt",
    props: {
        index: Number,
        links: Array,
        card: Object,
        restrict: Boolean
    },
    data()
    {
        return {
            showCard: false
        } 
    },
    methods:
    {
        filter($filter)
        {

            if (!Array.isArray($filter))
            {
                $filter = new Array($filter);
            }

            this.showCard = false;

            console.log("filter");

                if ($filter.length > 0 && $filter[0] != undefined)
                {                
                    console.log("filter exists", $filter);
                    if (this.card.tags && this.card.tags.length > 0)
                    {


                        console.log("tags", this.card.tags);

                        this.card.tags.forEach(c => {
                            $filter.forEach(f => {

                                if (c == f)
                                {
                                    console.log("match", c, f);
                                    this.showCard = true;
                                }
                            });
                        })         

                        if (this.showCard === false)
                        {
                            console.log("no tag match, force off");
                            this.showCard = false;
                        }     
                        else{
                            console.log("still showing", this.showCard);
                        }
                    }
                    else
                    {
                        this.showCard = false;
                        console.log("no tag");
                    }
                }
                else
                {
                        console.log("no filters applied");
                    this.showCard = true;
                }
 

                
        }
    },
    mounted(){

        if (this.$route.query.filter != undefined)
            this.filter(this.$route.query.filter);

        let self = this;

        this.$root.$on('filterstate', $filter => {
            
            self.filter($filter);

        });

        
    },
    computed: {
 
            isThis: function()
            {
                return this.card.url == this.$route.path;
            }    
        
    },
    data()
    {

        return {
            showCard: true,
            cardLinks: this.links ? this.links : [{title: "View project"}],
            multilink: this.card.cta && this.card.cta.length > 1
        }
    }
}
